import { createAction, type QueuedAction } from "@/v2/hooks/useActionQueue";
import { apiCall, type ActionDeps } from "./types";

export type EditPayload = {
	id: number;
	date: string;
	matter: string;
	matter_id: string;
	description: string;
	duration: number;
	task: string;
	activity: string;
};

export function editAction(entry: EditPayload, deps: ActionDeps): QueuedAction {
	const rollback = deps.updateEntries((prev) =>
		prev.map((e) => (e.id === entry.id ? { ...e, ...entry } : e)),
	);

	return createAction({
		execute: () =>
			apiCall(deps, {
				endpoint: "/records/edit",
				method: "POST",
				body: entry,
			}),
		rollback,
		toast: {
			loading: "Saving changes…",
			success: "Entry saved",
			error: "Failed to save entry",
		},
		onSuccess: () => deps.refreshRecords(),
		onError: () => deps.refreshRecords(),
	});
}
